import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  link: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'normal',
    marginBottom: '0.8rem',
  },
  icon: {
    marginLeft: 8,
    fontSize: 20,
  },
});

export default useStyles;
